import React, { useEffect, useState } from 'react';
import { Form } from 'react-bootstrap';
import ClientSearchSelect from '../../../utils/ClientSearchSelect';

/**
 * ClienteSelector - Component for selecting client with async search and create option
 * @param {Object} props.value - Selected client data object
 * @param {Function} props.onChange - Change handler receiving client data object
 * @param {Function} props.onCrearCliente - Handler for create client button click
 */
const ClienteSelector = ({ value, onChange, onCrearCliente, disabled = false }) => {
    // Internal option state for the async select
    const [clienteOption, setClienteOption] = useState(null);

    // Sync external value (e.g. after creating a new client) → internal option
    useEffect(() => {
        if (!value) {
            setClienteOption(null);
            return;
        }
        const partes = [value.nombre];
        if (value.identificacion) partes.push(value.identificacion);
        if (value.ciudad) partes.push(value.ciudad);
        setClienteOption({ value: value._id, label: partes.join(' · '), data: value });
    }, [value]);

    const handleChange = (option) => {
        setClienteOption(option);
        onChange(option?.data || null);
    };

    return (
        <Form.Group className="mb-3">
            <Form.Label className='bold'> Cliente *</Form.Label>
            <ClientSearchSelect
                value={clienteOption}
                onChange={handleChange}
                menuPortalTarget={document.body}
                isDisabled={disabled}
            />
            <div className="mt-1">
                <button
                    type="button"
                    className="btn btn-link btn-sm p-0"
                    onClick={onCrearCliente}
                    disabled={disabled}
                >
                    + Crear nuevo cliente...
                </button>
            </div>
        </Form.Group>
    );
};

export default ClienteSelector;
